import { IconCloudUp, IconLoader2, IconPlus, IconTrashFilled, IconX } from '@tabler/icons-react'
import { useEffect, useState } from 'react'
import { useSkuAPI, useSkuAPIs } from 'src/API/rest.sku'
import { ButtonIconSquare } from 'src/components/buttons'
import { StandardAlertDialog } from 'src/components/standard.alert-dialog'
import { InputStandard } from 'src/components/standard.input'
import { StandardTable, StandardTableHeader, StandardTableRow, TablePlater } from 'src/components/standard.table'
import { toast } from 'src/shadcn/ui/use-toast'
import { Pagination, PaginationKeys } from 'src/types/pagination'
import { useDebounce } from 'use-debounce'
import { StandardTablePagination } from '../../../../../components/standard.pagination'
import { ModalAddProduct } from './component.addModal'
import { DropdownMenuDemo, DropdownMenuMain } from './component.dropdownMenu'
import { FilterModal } from './component.filterModal'
import { ImportExcelModal } from './component.importExcelModal'
import { ModalValidationError } from './component.validationErrorModal'
import { useLocation, useNavigate } from 'react-router-dom'





export function SKUPage() {

    const searchParams = new URLSearchParams(window.location.search)
    const currentPageFromUrl = searchParams.get(PaginationKeys.CURRENT_PAGE)
    const dataPerPage = 15
    const [pagination, setPagination] = useState<Pagination>({
        currentPage: currentPageFromUrl ? parseInt(currentPageFromUrl) : 1,
        totalPages: Math.ceil(1 / dataPerPage) || 1,
        dataPerPage: dataPerPage
    })
    const [skuRow, setSkuRow] = useState<StandardTableRow[]>([])
    const [previousDataLength, setPreviousDataLength] = useState(0)
    const [openAddModal, setOpenAddModal] = useState(false)
    const [openImportModal, setOpenImportModal] = useState(false)
    const [selectedSkuId, setSelectedSKUId] = useState<number | null | string>()
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [mode, setMode] = useState<'add' | 'edit'>('add')
    const [search, setSearch] = useState('')
    const [debouncedInput] = useDebounce(search, 500);
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [productCategory, setproductCategory] = useState<number[]>([]);
    const [productSubCategory, setproductSubCategory] = useState<number[]>([]);
    const [productId, setproductId] = useState<number[]>([]);
    const [status, setStatus] = useState<'All' | '1' | '0'>('1')
    const location = useLocation();
    const navigate = useNavigate()

    const {
        downloadSKUDatas,
        isDownloadingSKUDatas
    } = useSkuAPIs()

    const {
        skus,
        error,
        isError,
        isFetched,
        isFetching,
        isLoading,
        totalSkuCount,
        isDeleting,
        refetchSkus,
        deleteSkuById,

    } = useSkuAPI({
        page_size: pagination.dataPerPage,
        page: pagination.currentPage,
        search: debouncedInput,
        FM15_Status: status === 'All' ? undefined : Number(status) as 1 | 0,
        FM14_M12_ProductCategory: productCategory,
        FM14_M12_ProductSubCategory: productSubCategory,
        FM15_M13_ProductID: productId
    })



    const headers: StandardTableHeader[] = [
        { label: 'SI No', id: 'SI_No' },
        { label: 'SKU Code', id: 'SKUCode' },
        { label: 'EAN Code', id: 'EANCode' },
        { label: 'SKU Name', id: 'SKUName' },
        { label: 'Product', id: 'Product' },
        { label: 'Category', id: 'Category' },
        { label: 'Style', id: 'Style' },
        { label: '', id: 'actions', width: '10px' },
    ]



    const deleteSKU = async () => {

        if (selectedSkuId) {
            const response = await deleteSkuById({
                skuId: selectedSkuId
            })
            if (response.success === true) {
                toast({
                    title: 'Success',
                    description: response.message,
                })
                refetchSkus()
                setOpenDeleteModal(false)
            } else {
                toast({
                    title: 'Error',
                    description: response.message,
                })
            }
            setSelectedSKUId(null)
        }

    }


    useEffect(
        () => {
            // setting prevouse data length for loading optimization
            if (isFetched && !isFetching) {
                console.log(skus?.length)
                setPreviousDataLength(skus?.length || 0)
            }

            //if successfully loaded
            if (isFetched && !isError) {
                setPagination({
                    currentPage: currentPageFromUrl ? parseInt(currentPageFromUrl) : 1,
                    totalPages: Math.ceil(totalSkuCount / dataPerPage) || 1,
                    dataPerPage: dataPerPage
                })
                setSkuRow(skus?.map(
                    (skus, index) => {
                        return ({
                            id: String(skus.FM15_SKUID),
                            datas: {
                                SI_No: { id: 'SI_No', data: (index + 1) + (pagination.currentPage - 1) * dataPerPage },
                                SKUCode: { id: 'SKUCode', data: skus.FM15_SKUCode },
                                EANCode: { id: 'EANCode', data: skus.FM15_EANCode },
                                SKUName: { id: 'SKUName', data: skus.FM15_SKUName },
                                Product: { id: 'Product', data: skus.FM15_M13_ProductID?.name },
                                Category: { id: 'Category', data: skus.FM14_M12_ProductCategory?.name },
                                Style: { id: 'Style', data: skus.FM15_M14_SubAttributeIDStyle?.name },
                                actions: {
                                    id: 'actions', data: <DropdownMenuDemo
                                        rowId={String(skus.FM15_SKUID)}
                                        onDeleteAction={(rowid) => {
                                            setSelectedSKUId(rowid);
                                            setOpenDeleteModal(true);
                                        }}
                                        onEditAction={(rowid) => {
                                            setSelectedSKUId(rowid);
                                            setMode('edit');
                                            setOpenAddModal(true);
                                        }}
                                    />
                                }
                            }
                        })

                    }
                ) || [])
            }
            console.log(skuRow)
            if (isError && isFetching === false) {
                toast({
                    description: String(error),
                })

            }
        }, [isFetching]
    )


    return (
        <div className=' grow  flex flex-col overflow-auto'>
            <StandardAlertDialog
                title="Are you absolutely sure?"
                description="This action cannot be undone. Are you sure you want to delete this product?"
                positiveLabel="Delete"
                negativeLabel="Cancel"
                positiveAction={deleteSKU}
                negativeAction={() => setOpenDeleteModal(false)}
                positiveIcon={isDeleting ? <IconLoader2 size={16} className=" animate-spin" /> : <IconTrashFilled size={16} />}
                negativeIcon={<IconX size={16} />}
                disableNegativeButton={isDeleting}
                disablePositiveButton={isDeleting}
                show={openDeleteModal}
            />
            <ModalAddProduct
                show={openAddModal}
                setShow={setOpenAddModal}
                refetchSkus={refetchSkus}
                mode={mode}
                productId={selectedSkuId}
            />
            <ImportExcelModal
                show={openImportModal}
                setShow={setOpenImportModal}
            />

            <FilterModal
                ProductCategory={productCategory}
                productSubCategory={productSubCategory}
                productId={productId}
                show={openFilterModal}
                status={status}
                setShow={setOpenFilterModal}
                search={(filter) => {
                    setproductCategory(filter.productCategory);
                    setproductSubCategory(filter.productSubCategory);
                    setproductId(filter.productId);
                    setStatus(filter.status);
                }}
            />
            <TablePlater className=' flex flex-col gap-2'>
                {/* Buttons section */}
                <div className=' flex justify-end w-full gap-4'>
                    <InputStandard onChange={(e) => {
                        setSearch(e.target.value)
                        setPagination({ ...pagination, currentPage: 1 })
                        const searchParams = new URLSearchParams(location.search);
                        searchParams.set(PaginationKeys.CURRENT_PAGE, '1');
                        navigate(`${location.pathname}?${searchParams.toString()}`);

                    }} className=' lg:w-[400px] ' placeholder='Search' />

                    {/* <ButtonIconSquare variant="primary" icon={<IconSortDescending />} text="Filter" onClick={() => { }} /> */}
                    <ButtonIconSquare variant="white" icon={<IconCloudUp />} text="Import" onClick={() => { setOpenImportModal(true) }} />
                    <ButtonIconSquare variant="secondary" icon={<IconPlus />} text="Add sku" onClick={() => { setMode('add'); setOpenAddModal(true); }} />
                    <DropdownMenuMain
                        onIconDownloadPressed={() => { downloadSKUDatas() }}
                        onFilterButtonPressed={() => setOpenFilterModal(true)}
                    />
                </div>
                <StandardTable
                    headers={headers}
                    rows={skuRow}
                    isLoading={isLoading}
                    rowsPerPrevousePage={previousDataLength}
                    isUpdating={isFetching}
                    isError={isError && isFetching === false}
                    onRetry={() => refetchSkus()}
                />
                <StandardTablePagination currentPage={pagination.currentPage} totalPages={pagination.totalPages} onChangePage={(page) => {
                    setPagination({ ...pagination, currentPage: page })
                }} />

            </TablePlater>
        </div>
    )

}



